export const questionTypes = Object.freeze({
  MONEY: 'MONEY',
  RADIO: 'RADIO',
  MULTIPLE_CHECK: 'MULTIPLE_CHECK'
});
